import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {BrowserRouter as Router} from 'react-router-dom';
import {Provider} from 'react-redux'
import 'antd/dist/antd.css';
import { configureStore } from "@reduxjs/toolkit";
import {api} from './features/api'
import {bingApi} from './features/bingApi'

const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    [bingApi.reducerPath]: bingApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      api.middleware,
      bingApi.middleware,
    ]
  ),
});

ReactDOM.render(
  <Router>
    <Provider store={store}>
      <App />
    </Provider>
  </Router>,
  document.getElementById('root')
);